import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, HostBinding, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CharacterSwatchComponent } from '../../dialogs/custom-symbol-dialog/character-swatch/character-swatch.component';

@Component({
  selector: 'app-custom-symbol-display',
  templateUrl: './custom-symbol-display.component.html',
  styleUrls: ['./custom-symbol-display.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomSymbolDisplayComponent implements AfterViewInit {
  @HostBinding('class.hidden') hidden: boolean = true;

  private _symbol: string = '';

  public font: string = '';
  public char: string = '';
  private _size: string = '';
  public set size(sz: string | number) {
    this._size = '' + sz;
    this.Refresh();
  }
  public get size(): string | number {
    return this._size;
  }
  public get charCode(): number {
    return Number('0x' + this.char);
  }
  public x: number = 0;
  public y: number = 0;
  public fontSize: string | number;
  public theta: number = 0;
  @ViewChild(CharacterSwatchComponent) swatch: CharacterSwatchComponent;
  @Input() set symbol(sym: string | number) {
    if(typeof sym !== 'string') return;
    this._symbol = sym;
    const custom = sym.split(':');

    if (custom.length > 0 && (custom[0] === 'custom')) {
      const [font, char, size, x, y, theta] = custom[1]?.split(',');
      this.font = font;
      this.char = char;
      this.size = '14pt';
      this.fontSize = size + 'pt';
      this.x = Number(x);
      this.y = Number(y);
      this.theta = Number(theta);
    }

    this.Refresh();
  }
  @Output() edit = new EventEmitter<string>();

  constructor(private cdr: ChangeDetectorRef) { }
  HasSymbol(): boolean {
    if (this._symbol !== '') return false;
    if (this._symbol.indexOf('custom:') !== 0) return false;
    return true;
  }
  ngAfterViewInit(): void {
    this._ready = true;
    if (this._symbol !== '') {
      this.symbol = this._symbol;
      this.hidden = false;
    }
    this.Refresh();
  }
  Edit(event) {
    event.stopImmediatePropagation();
    this.edit.emit(this._symbol);
  }
  public _ready = false;
  public Refresh() {
    if (!this._ready) return;
    this.cdr.detectChanges();
  }

}
